export default __webpack_public_path__ + "fonts/contact-has-no-data-icon.svg";